// import MaterialTable from 'material-table';
import React, { useEffect, useState } from 'react'
import Service from '../Networking/NetworkingUtils';
import { getCookie } from '../Utils/CookieHelper';
import CloseIcon from '@mui/icons-material/Close';
import ModelLibrary from '../ModelLibrary/ModelLibrary';
import { AppBar, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Toolbar, Tooltip, Typography } from '@mui/material';
import { useSnackbar} from 'notistack';
import AddBoxIcon from '@mui/icons-material/AddBox';
import moment from 'moment';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';


var token = getCookie("bb_metaverse_token");
const user = JSON.parse(getCookie("bb_metaverse_user"));

const ModelCategory = () => {

    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = useState(false)
    const [rowData, setRowData] = useState({})
    const [columns] = useState([
        { title: 'Name', field: 'name' },
        { title: 'Description', field: 'description' },
        {
            title: 'Date Created', field: 'date_created', type: 'date',
            render: rowData => { return moment(rowData.date_created).format('DD/MM/YYYY') }
        },
    ])
    const [dialogopen, setDialogopen] = useState(false)
    const [addData, setAddData] = useState({})
    const [isEdit, setIsEdit] = useState(false)
    const [editObj, setEditObj] = useState({})
    const [search, setSearch] = useState('')


    const getData = () => {
        setIsLoading(true)
        Service.get('/api/modular/category/get_modular_categories/', {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => {
            setData(res.data)
            setIsLoading(false)
        }).catch(error => {
            console.log(error)
            enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            })
            setIsLoading(false)
        }
        )
    }

    const postData = (data) => {
        setIsLoading(true)
        data.created_by = user.id
        Service.post('/api/modular/category/create_modular_category/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: data,
        }).then(res => {
            getData()
            enqueueSnackbar('Model added Successfully!', {
                variant: 'success'
            })
            setDialogopen(false)
        }).catch(error => {
            console.log(error)
            enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            })
            setIsLoading(false)
        }
        )
    }

    const editData = (data) => {
        setIsLoading(true)
        data.created_by = user.id
        Service.patch(`/api/modular/category/update_modular_category/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: data
        })
            .then(res => {
                setDialogopen(false)
                enqueueSnackbar('Model edited Successfully', {
                    variant: 'success'
                });
                getData()
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    const submit = () => {
        if (addData.name && addData.description) {
            postData(addData)
        } else {
            enqueueSnackbar('Please fill all fields', {
                variant: 'warning'
            })
        }
    }


    useEffect(() => {
        getData()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const filteredData = data.filter(row =>
        columns.some(column => String(column.render ? column.render(row) : row[column.field] || '').toLowerCase().includes(search.toLowerCase()))
    )



    return (
        <div>
            {/* <MaterialTable
                title="Model Category"
                columns={[
                    { title: 'Name', field: 'name' },
                    { title: 'Description', field: 'description' },
                    { title: 'Date Created', field: 'date_created', type: 'date' },
                ]}
                isLoading={isLoading}
                data={data}
                // detailPanel={rowData =>
                //     <Box margin={2}>
                //         <ModelVersion model={rowData} />
                //     </Box>
                // }
                onRowClick={(event, rowData, togglePanel) => {setOpen(true);setRowData(rowData)}}
                editable={{
                    onRowAdd: newData =>
                        new Promise((resolve, reject) => {
                            postData(newData)
                            resolve();
                        }),
                    onRowUpdate: (newData, oldData) =>
                        new Promise((resolve, reject) => {
                            editData(newData)
                            resolve();
                        }),
                    // onRowDelete: oldData =>
                    //   new Promise((resolve, reject) => {
                    //     setTimeout(() => {
                    //       deleteData(oldData)
                    //       const dataDelete = [...data];
                    //       const index = oldData.tableData.id;
                    //       dataDelete.splice(index, 1);
                    //       setData([...dataDelete]);
                    //       resolve()
                    //     }, 1000)
                    //   }),
                }}

                options={{
                    padding: "dense",
                    paging: false,
                    filtering: true,
                    actionsColumnIndex: -1
                }}
            /> */}
            {isLoading ? <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width='100%'><CircularProgress /></Box> :
                <TableContainer  component={Paper} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                    <Box display='flex' justifyContent='space-between' alignItems='center' width='100%' padding='14px 16px 10px'>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                fontSize: 20,
                            }}
                        >
                            Model Category
                        </Typography>
                        <Box display='flex' alignItems='center' gap={1}>
                            <TextField
                                size='small'
                                variant='outlined'
                                placeholder='Search'
                                value={search}
                                onChange={(event) => setSearch(event.target.value)}
                                InputProps={{ endAdornment: <SearchIcon /> }}
                            />
                            <Tooltip title="Add"><span><IconButton onClick={() => { setDialogopen(true); setIsEdit(false); }}><AddBoxIcon /></IconButton></span></Tooltip>
                        </Box>
                    </Box>
                    <React.Fragment>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                    {columns && columns.map((column) => (
                                        <TableCell key={column.field} sx={{ fontWeight: 700 }}>{column.title}</TableCell>
                                    ))}
                                    <TableCell align='center' sx={{ fontWeight: 700 }}>
                                        Actions
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData && filteredData.map((row) => (
                                    <React.Fragment key={row.id}>
                                        <TableRow onClick={() => { setOpen(true); setRowData(row) }} sx={{ cursor: 'pointer' }}>
                                            {columns && columns.map((column) => (
                                                <TableCell key={column.field}  >
                                                    {column.render ? column.render(row) : column.lookup ? column.lookup[row[column.field]] : row[column.field]}
                                                </TableCell>
                                            ))}
                                            <TableCell align='center'>
                                                <Tooltip title="Edit">
                                                    <IconButton onClick={(e) => { e.stopPropagation(); setDialogopen(true); setEditObj(row); setIsEdit(true) }}><EditIcon /></IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>

                    </React.Fragment>
                </TableContainer>}
            <Dialog maxWidth="xs" fullWidth={true} open={dialogopen} onClose={() => setDialogopen(false)}>
                <DialogTitle marginTop="2px" spacing={2}>{isEdit ? 'Edit Model Category' : 'Add Model Category'}</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "column" }}>
                        <TextField variant='outlined' id="name" fullWidth label='Name' value={isEdit ? editObj.name : addData.name} onChange={(e) =>{isEdit ? setEditObj({...editObj, name: e.target.value }) : setAddData({ ...addData, name: e.target.value })}} sx={{ marginTop: '10px' }}></TextField>
                        <TextField variant='outlined' id="description" fullWidth label='Description' value={isEdit ? editObj.description : addData.description} sx={{ marginTop: '5px' }} onChange={(e) => {isEdit ? setEditObj({...editObj, description: e.target.value }) : setAddData({ ...addData, description: e.target.value })}}></TextField>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" variant="text" onClick={() => setDialogopen(false)}>Cancel</Button>
                    <Button color="primary" variant="text" onClick={(e) => {isEdit ? editData(editObj) : submit(e)}}>{isEdit ? 'Edit' : 'Add'}</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullScreen open={open} onClose={() => setOpen(false)}>
                <AppBar position="static">
                    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
                            <IconButton
                                size="large"
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                sx={{ mr: 2 }}
                                onClick={() => setOpen(false)}
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                                {rowData.name}
                            </Typography>
                        </Box>
                    </Toolbar>
                </AppBar>
                <Box margin={2}>
                    <ModelLibrary rowData={rowData} />
                </Box>
            </Dialog>
        </div>
    )
}

// export default withSnackbar(ModelCategory)
export default ModelCategory;